import { IHinhThucGiangActionTypes } from "../../action-types/category/IHinhThucGiangActions";
import { IHinhThucGiangReducer } from "../../reducer-model/category/IHinhThucGiangReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IHinhThucGiangReducer = {
    status: eReducerStatusBase.is_not_initialization,
    hinhThucGiangs: [],
};

export const hinhThucGiangReducer = (state: IHinhThucGiangReducer = initialState, action: IHinhThucGiangActionTypes): IHinhThucGiangReducer => {
    switch (action.type) {
        case "HINH_THUC_GIANG_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "HINH_THUC_GIANG_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                hinhThucGiangs: action.payload,
            };
        case "HINH_THUC_GIANG_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}